import React, { useEffect } from "react";
import { BrowserRouter, Route, Routes, Navigate, useLocation, useNavigationType } from "react-router-dom";
import "./styles/global.css";
//회사소개
import MainPage from "./pages/MainPage";
import IntroductionPage from "./pages/IntroductionPage";
import LeadPage from "./pages/LeadPage";

// 채용
import RecruitTeam from "./pages/RecruitTeamCulture";
import RecruitApply from "./pages/RecruitApply";
import RecruitNotice from "./pages/RecruitNotice";
import RecruitDetail from "./pages/RecruitDetail";

// Business
import SalesForcePage from "./pages/BusinessSalesforce";
import AgentForce from "./pages/BusinessAgentforce";
import SnowFlake from "./pages/BusinessSnowflake";
import Databricks from "./pages/BusinessDatabricks";
import Integrate from "./pages/BusinessIntegrate";
import Dreamfactory from "./pages/BusinessDreamfactory";
import ServiceIncubation from "./pages/BusinessIncubation";
import ICTConvergence from "./pages/BusinessICT";

import CustomerPage from "./pages/CustomerPage";
import ContactPage from "./pages/ContactPage";
import PolicyPage from "./pages/PolicyPage";
import ContactIntro from "./pages/ContactIntro";
import StoreIntro from "./pages/Store";
import ExternalRedirect from "./components/ExternalRedirect";
import StoreDetail from "./pages/StoreDetail";

const GA_ID = 'G-FBQV8HWXHS';

const injectGAScript = () => {
    // window.gtag는 global.d.ts 파일에서 타입을 정의해야 합니다.
    if (!window.gtag) {
        const script1 = document.createElement('script');
        script1.async = true;
        script1.src = `https://www.googletagmanager.com/gtag/js?id=${GA_ID}`;
        document.head.appendChild(script1);

        const script2 = document.createElement('script');
        script2.innerHTML = `
          window.dataLayer = window.dataLayer || [];
          function gtag(){dataLayer.push(arguments);}
          gtag('js', new Date());
          gtag('config', '${GA_ID}');
        `;
        document.head.appendChild(script2);
    }
};

const AnalyticsTracker: React.FC = () => {
    const location = useLocation();

    useEffect(() => {
        if (window.gtag) {
            const pagePath = location.pathname + location.search;

            // GA4는 'config' 명령어를 사용하여 새로운 페이지 뷰를 전송합니다.
            window.gtag('config', GA_ID, {
                page_path: pagePath,
            });
        }
    }, [location.pathname, location.search]);

    return null;
};

const ScrollToTop: React.FC = () => {
    const { pathname, hash } = useLocation();
    const navigationType = useNavigationType();

    useEffect(() => {
        if (hash) return;
        if (navigationType === "POP") return;
        // 전역 scroll-behavior: smooth 때문에 기본 호출은 0.7초간 애니메이션으로
        // 돈다. 그 사이 사용자가 앵커를 누르면 두 스크롤이 경합해 삼켜진다.
        window.scrollTo({ top: 0, behavior: "instant" as ScrollBehavior });
    }, [pathname, hash, navigationType]);

    return null;
};


function App() {
    useEffect(() => {
        injectGAScript();
    }, []);

    return (
        <>
            <BrowserRouter>
                {/* AnalyticsTracker는 URL 변경을 감지해야 하므로 <BrowserRouter> 내부에 위치해야 합니다. */}
                <AnalyticsTracker />
                <ScrollToTop />

                <Routes>
                    <Route path="/main" element={<MainPage />} />
                    <Route path="/about" element={<IntroductionPage />} />
                    <Route path="/lead" element={<LeadPage />} />

                    <Route path="/customer" element={<CustomerPage />} />
                    <Route path="/contact" element={<ContactPage />} />
                    <Route path="/contact-intro" element={<ContactIntro />} />
                    {/* 비즈니스 */}
                    <Route path="/dt" element={<SalesForcePage />} />
                    <Route path="/agent" element={<AgentForce />} />
                    <Route path="/databricks" element={<Databricks />} />
                    <Route path="/snowflake" element={<SnowFlake />} />
                    <Route path="/integrate" element={<Integrate />} />
                    <Route path="/dreamfactory" element={<Dreamfactory />} />
                    <Route
                        path="/service-incubation"
                        element={<ServiceIncubation />}
                    />
                    <Route path="/ICT" element={<ICTConvergence />} />

                    {/* 채용 */}
                    <Route path="/recruit" element={<RecruitTeam />} />
                    <Route path="/recruit/jobs" element={<RecruitNotice />} />
                    <Route
                        path="/recruit/jobs/detail/:id"
                        element={<RecruitDetail />}
                    />
                    <Route path="/recruit/apply" element={<RecruitApply />} />

                    {/* 기타 */}
                    <Route path="/store" element={<StoreIntro />} />
                    <Route path="/store/detail" element={<StoreDetail />} />
                    <Route path="/policy" element={<PolicyPage />} />
                    <Route
                        path="/handson"
                        element={<ExternalRedirect url="https://kusrc-webinar.herokuapp.com/demo/datacloude_handson" />}
                    />
                    <Route path="/" element={<Navigate replace to="/main" />} />
                </Routes>
            </BrowserRouter>
        </>
    );
}

export default App;